import { Navigate, Outlet, useSearchParams } from 'react-router'

import { safeNext } from '@/lib/url'

import { useUser } from './use-user'

export function GuestRoute() {
  const { user, isLoading } = useUser()
  const [params] = useSearchParams()

  if (isLoading) return null
  /** signing in races the login form's own navigate(next), so both go to the
   *  same place. without a next, the role-aware root redirect picks the
   *  landing: supers go to platform metrics, members to their home. */
  if (user) return <Navigate to={safeNext(params.get('next'))} replace />
  return <Outlet />
}
